import React, { useEffect, useState } from 'react'
import { Page, Text, View, Document, StyleSheet, PDFViewer, Image,PDFDownloadLink } from '@react-pdf/renderer';
import 'bootstrap/dist/css/bootstrap.min.css';
import { v4 as uuidv4 } from 'uuid';
import { Col, Row } from 'react-bootstrap';
import '../CustomerPortal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faFilePdf, faIdCardClip, faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { TransactionTable } from '../../components/TransactionTable/TransactionTable';
import BackEndUrl from '../../backURL';
import axios from 'axios';
import { Loader } from '../../components/loaders/Loader';
import logo from "../../Images/logo.png";
import { Button } from '@nextui-org/react';
const backend = BackEndUrl.domain;
function getCurrentDate() {
    const currentDate = new Date();
    const options = {
        timeZone: 'Asia/Colombo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    };

    return currentDate.toLocaleString('en-GB', options);
}
const capitalizeEachWord = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
};
function formatDate(dateString) {

     // Handle special case of "0000-00-00" or other known invalid formats
     if (dateString === '0000-00-00' || !dateString) {
        return 'Date not specified!';
    }


    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month is zero-based, so we add 1
    const year = date.getFullYear();

    return day + '/' + month + '/' + year;
}
const data = [
    {
        "key": "qtyt1",
        "premium_payment": 2003,
        "adjustments": "none",
        "user_id": 11,
        "date": "2024-04-03T07:51:30.000Z",
        "policy_number": 270670
    }
]

const styles = StyleSheet.create({
    page: {
        width: 200,
        backgroundColor: '#ffffff'
    },
    '@media (max-width: 400)': {
        page: {
            width: 300,
        },
    },
    '@media (orientation: landscape)': {
        page: {
            width: 400,
        },
    },
    header: {
        margin: 10,
        padding: 10,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",

    }
    , logo: {
        width: '60px',
        height: '60px'
    }
    , date: {
        fontSize: 12
    },
    heading: {
        fontSize: '25px',
        fontWeight: 800,

    },
    heading2: {
        fontSize: '15px',
        fontWeight: 900,
        textDecoration: "underline",
        marginLeft: "30px",
        marginTop: "10px"

    }
    , policyInfo: {
        flexDirection: 'row',
        justifyContent: "space-between",
        marginLeft: "30px"


    }
    , coverage: {
        flexDirection: 'row',

    }
    , subheading: {
        fontWeight: "bold", textDecoration: 'underline',
        fontSize: "13px",
        marginVertical: "15px",
    },
    table: {
        display: "table",
        width: "100%",

        borderCollapse: "collapse",
        paddingHorizontal: "30px",
        
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCellHeader: {
        width: "33.33%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        padding: 5,
        backgroundColor: "#f2f2f2",
        fontSize: "12px"
    },
    tableCell: {
        width: "33.33%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        padding: 5,
        fontSize: "11px"
    },
    section: {
        marginTop: 20,
    },
    sectionTitle: {
        fontSize: 14,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    sectionContent: {
        fontSize: "11px",
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 30,
        right: 30,
    },
    disclaimer: {
        fontSize: 10,
        marginBottom: 5,
    },
    unsubscribe: {
        fontSize: 10,
    },

});

// Create Document Component

export const Estatement = ({ policy_number }) => {
    const [premiumInfo, setPremiumInfo] = useState(null);
    const [coverageInfo, setCoverageInfo] = useState(null);
    const [trasactionInfo, setTrasactionInfo] = useState(null);
    const [policyInfo, setPolicyInfo] = useState(null);
    const securityInfo = [
        "All e-statements are encrypted to ensure confidentiality.",
        "Secure servers are used to store e-statement data.",
        "Two-factor authentication is implemented for account access.",
    ];
    const contactInfo = [
        "Customer Service: +94 11 200 2021",
        "Email: info@sicl.lk.",
        "Website: https://www.sicl.lk/",
    ];
   
    
    const MyDocument = () => (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <Image src={logo} style={styles.logo} />
                    <Text style={styles.heading}>E-Statement</Text>
                    <View style={styles.section}>
                        <Text style={styles.date}>Date :{getCurrentDate()}</Text>
                    </View>
                </View>
                <View style={styles.policyInfo}>
                    <View style={{ fontSize: "11px" }}>
                        <Text>{capitalizeEachWord(policyInfo?.policy_fullname)}</Text>
                        <Text style={{ marginTop: "5px" }}>{`${policyInfo?.policy_address1} ,`}</Text>
                        <Text>{`${policyInfo?.policy_address2} ,`}</Text>
                        <Text>{`${policyInfo?.policy_address3} ,`}</Text>
                        <Text>{`${policyInfo?.policy_address4} .`}</Text>
                    </View>
                    <View style={{ fontSize: "11px", marginHorizontal: "20px" }}>
                        <Text>Policy Number : {policyInfo?.policy_number}</Text>
                        <View style={styles.coverage}>
                            <Text>Coverage :</Text>
                            <View>
                                {coverageInfo?.map((value) => {
                                    return (
                                        <Text style={{ marginLeft: "5px" }}>{value?.coverage_type} -{value?.coverage_amount}</Text>
                                    )
                                })}
                            </View>
                        </View>
                    </View>



                </View>
                <View style={{
                    marginLeft: "30px"
                }}>
                    <Text style={styles.subheading}>Premium Information</Text>
                    <Text style={{ fontSize: "12px" }}>Premium Amount : {premiumInfo&&premiumInfo[0]?.premium}</Text>
                    {/* <Text style={{ fontSize: "12px" }}>Date : {premiumInfo&&premiumInfo[0]?.mdate}</Text>
                    <Text style={{ fontSize: "12px" }}>Due Date : {formatDate(premiumInfo&&premiumInfo[0]?.dues)}</Text> */}
                </View>
                <View style={{
                    marginLeft: "30px",marginTop:"10px"
                }}>
                    <Text style={styles.subheading}>Trasaction History</Text>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCellHeader}>
                            <Text>Date</Text>
                        </View>
                        <View style={styles.tableCellHeader}>
                            <Text>Premium Payment</Text>
                        </View>
                        <View style={styles.tableCellHeader}>
                            <Text>Due</Text>
                        </View>
                        <View style={styles.tableCellHeader}>
                            <Text>Receipt No</Text>
                        </View>
                    </View>
                    {premiumInfo?.map((transaction, index) => (
                        <View style={styles.tableRow} key={index}>
                            <View style={styles.tableCell}>
                                <Text>{formatDate(transaction.mdate)}</Text>
                            </View>
                            <View style={styles.tableCell}>
                                <Text>Rs. {transaction.premium}</Text>
                            </View>
                            <View style={styles.tableCell}>
                                <Text>{transaction.dues}</Text>
                            </View>
                            <View style={styles.tableCell}>
                                <Text>{transaction.receipt_no}</Text>
                            </View>
                        </View>
                    ))}
                </View>
               

                {/* Contact Information */}
                <View style={{ marginLeft: "30px" }}>
                    <Text style={styles.subheading}>Contact Information:</Text>
                    {contactInfo.map((info, index) => (
                        <Text key={index} style={styles.sectionContent}>
                            {info}
                        </Text>
                    ))}
                </View>

                {/* Security Information */}
                <View style={{ marginLeft: "30px" }}>
                    <Text style={styles.subheading}>Security Information:</Text>
                    {securityInfo.map((info, index) => (
                        <Text key={index} style={styles.sectionContent}>
                            {info}
                        </Text>
                    ))}
                </View>

                {/* Footer Section */}
                <View style={styles.footer}>
                    <Text style={styles.disclaimer}>
                        Include a disclaimer regarding the accuracy of the statement and the need to contact the insurance company for clarifications.
                    </Text>
                    <Text style={styles.unsubscribe}>
                       If applicable, provide an option for the policyholder to unsubscribe from e-statements.
                    </Text>
                </View>

            </Page>
        </Document>
    );
    useEffect(() => {
        async function GetPremimumInfo() {
            try {

                const response = await axios.post(backend + "/premium-info", {
                    policy_number: policy_number,

                }, {
                    headers: {
                        Authorization: sessionStorage.getItem('token'),
                    }
                });
                setPremiumInfo(response.data);
                //console.log("Pay Details : "+response.data);







            } catch (error) {
                console.log(error);
            }
        }
        async function GetCoverageInfo() {
            try {

                const response = await axios.post(backend + "/coverage-info", {
                    policy_number: policy_number,

                }, {
                    headers: {
                        Authorization: sessionStorage.getItem('token'),
                    }
                });
                setCoverageInfo(response.data);







            } catch (error) {
                console.log(error);
            }
        }
        async function GetPolicyInfo() {
            try {

                const response = await axios.post(backend + "/e-statement-policy-info", {
                    policy_number: policy_number,

                }, {
                    headers: {
                        Authorization: sessionStorage.getItem('token'),
                    }
                });

                setPolicyInfo(response.data[0]);







            } catch (error) {
                console.log(error);
            }
        }
        async function GetTrasactionInfo() {
            try {

                const response = await axios.post(backend + "/transction-info", {
                    policy_number: policy_number,

                }, {
                    headers: {
                        Authorization: sessionStorage.getItem('token'),
                    }
                });
                return (response.data);







            } catch (error) {
                console.log(error);
            }
        }

        if (!trasactionInfo) {
            async function fetchData() {
                const data = await GetTrasactionInfo();
                if (data && Array.isArray(data)) {
                    // Add unique keys to each object in the array
                    const updatedTrasactionInfo = data.map(obj => ({
                        ...obj,
                        key: uuidv4()
                    }));
                    setTrasactionInfo(updatedTrasactionInfo);
                }
            }
            fetchData();
        }
        if (!coverageInfo) {
            GetCoverageInfo();
        }
        if (!premiumInfo) {
            GetPremimumInfo();
        }
        if (!policyInfo) {
            GetPolicyInfo();
        }


    })


    return (
       <>
        <div className='d-flex justify-content-center my-3'>
            <PDFDownloadLink document={ <MyDocument />} fileName={`estatement${getCurrentDate()}.pdf`}>
        {({ blob, url, loading, error }) =>
          loading ?
            <Button isLoading style={{ color: "white", backgroundColor: "#F5190E" }} >
             Estatement Download
            </Button>

            :
            <Button  style={{ color: "white", backgroundColor: "#F5190E" }} >
              <FontAwesomeIcon icon={faFilePdf} style={{ height: "2.5vh" }} />
              Estatement Download
              
            </Button>
        }
      </PDFDownloadLink>

        </div>
        <div style={{ minHeight: "100vh" }}className='d-flex justify-content-center'>
           
        <Row className='d-flex justify-content-center'  style={{ width: '100%', height: '100%' }}>
      <Col xs={12} lg={8} style={{minHeight: "80vh" }}>
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
          <PDFViewer  showToolbar={false} style={{ width: '100%', height: '100%' }}>
            <MyDocument />
          </PDFViewer>
        </div>
      </Col>
    </Row>
        </div></>

    )
}
